import React, { useState, useEffect } from "react";
import LogoPoliSenzaScritta from "../images/logo_est_polito_EC_noBackgroud.png";
import InfoAlert from "../components/Modals/InfoAlert";
import { login } from "../actions/auth";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import "./Login.css";
import RegisterModal from "./RegisterModal";
import ForgottenPasswordModal from "./ForgottenPasswordModal";
import { FaSpinner } from "react-icons/fa";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import PdfAbout from "../pdf/Terms and conditions.pdf";
import { useWindowDimensions } from "../utils/useWindowDimensions";

export const Login = (props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showLoading, setShowLoading] = useState(false);
  const [isOpenAbout, setIsOpenAbout] = useState(false);
  const { width, height } = useWindowDimensions();

  const toggleAbout = () => setIsOpenAbout(!isOpenAbout);

  const [registerModalOpen, setRegisterModalOpen] = useState(false);
  const toggleRegisterModal = () => setRegisterModalOpen(!registerModalOpen);

  const [forgottenPassowrdOpen, setForgottenPassowrdOpen] = useState(false);
  const toggleForgottenPassowrd = () =>
    setForgottenPassowrdOpen(!forgottenPassowrdOpen);

  const onSubmit = async (e, setShowLoading) => {
    e.preventDefault();
    if (showLoading === false) {
      setShowLoading(true);
      await props.login(username, password);
      setShowLoading(false);
    }
  };

  if (props.auth.isAuthenticated) {
    return <Redirect to="/wrapper"></Redirect>;
  }

  return (
    <>
      <RegisterModal
        registerModalOpen={registerModalOpen}
        toggleRegisterModal={toggleRegisterModal}
      />
      <ForgottenPasswordModal
        forgottenPassowrdOpen={forgottenPassowrdOpen}
        toggleForgottenPassowrd={toggleForgottenPassowrd}
      />
      <div className="mainLogin">
        <div className="container" id="container">
          <div className="form-container sign-in-container">
            <form onSubmit={(e) => onSubmit(e, setShowLoading)}>
              <h1>Login</h1>
              <span style={{ marginBottom: 15 }}>insert your credentials</span>
              <input
                type="text"
                placeholder="Username"
                className="inputForm"
                onChange={(e) => setUsername(e.target.value)}
              />
              <input
                type="password"
                placeholder="Password"
                className="inputForm"
                onChange={(e) => setPassword(e.target.value)}
              />
              <p
                style={{
                  margin: 15,
                  padding: 0,
                  cursor: "pointer",
                  width: "100%",
                  textAlign: "right",
                  marginRight: -12,
                  marginTop: 0,
                  fontSize: 12,
                  color: "#0000FF",
                }}
                onClick={toggleForgottenPassowrd}
              >
                Forgot your password?
              </p>
              <button>
                Login{" "}
                {showLoading === true ? (
                  <FaSpinner
                    icon="spinner"
                    className="spinner"
                    style={{
                      fontSize: 16,
                      marginLeft: 10,
                      position: "absolute",
                      marginTop: 1,
                    }}
                  />
                ) : null}
              </button>
              <p>
                Don't have an account?
                <span
                  onClick={toggleRegisterModal}
                  style={{
                    fontSize: 14,
                    marginLeft: 2,
                    color: "#0000FF",
                    cursor: "pointer",
                  }}
                >
                  Register
                </span>
              </p>
            </form>
          </div>
          <div className="overlay-container">
            <div className="overlay">
              <div className="overlay-panel overlay-right">
                {/* <h1 style={{ marginBottom: 30 }}>Welcome</h1> */}
                <img
                  src={LogoPoliSenzaScritta}
                  style={{ width: "280px", height: "auto" }}
                ></img>
                <h4
                  style={{
                    marginBottom: 30,
                    fontWeight: "bold",
                    marginTop: 20,
                  }}
                >
                  … PLAT.form of energy
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            bottom: 15,
            color: "#A9A9A9",
            cursor: "pointer",
          }}
          onClick={toggleAbout}
        >
          Terms of use
        </div>
      </div>
      <Modal
        isOpen={isOpenAbout}
        toggle={toggleAbout}
        size="xl"
        className="modalLogin"
      >
        <ModalHeader toggle={toggleAbout}>Read the documentation</ModalHeader>
        <ModalBody style={{ padding: "20px" }}>
          <object
            data={PdfAbout}
            type="application/pdf"
            width="100%"
            height={height - 250}
          ></object>
        </ModalBody>

        <ModalFooter>
          <Button
            style={{
              boxShadow: "none",
            }}
            onClick={() => {
              toggleAbout();
            }}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { login })(Login);
